import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useMarkAsReadMutation } from "../store/api/notificationApiSlice";
import {
  closeNotificationModal,
  openNotificationModal,
  patchActiveNotification,
} from "../store/slices/appSlice";
import { getNotificationInboxId } from "../utils/notificationHelpers";

export function useNotificationModal() {
  const dispatch = useDispatch();
  const [markAsRead] = useMarkAsReadMutation();

  const open = useCallback(
    async (notification) => {
      if (!notification) return;

      dispatch(openNotificationModal(notification));

      const isUnread = !notification.isRead;
      const inboxId = getNotificationInboxId(notification);
      if (!isUnread || !inboxId) return;

      try {
        await markAsRead(inboxId).unwrap();
        dispatch(patchActiveNotification({ isRead: true }));
      } catch {
        // Modal gerçek durumu gösterir; rozet değişmez
      }
    },
    [dispatch, markAsRead]
  );

  const close = useCallback(() => {
    dispatch(closeNotificationModal());
  }, [dispatch]);

  return { open, close };
}
